<template>
  <div>
    <LessonHeader :hide-display="'hide_content'" />
    <div class="browser-container">
      <BrowserMessageDisplay :title="title" :description="description" />
      <div class="row-center">
        <el-button
          type="primary"
          size="large"
          @click="goToBizmatesPortal"
        >Go Back to MyBizmates Portal</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { redirectToHome } from '@/utils/common';
import { errorCodes } from '@/utils/constants';
import BrowserMessageDisplay from '@/components/Browser/MessageDisplay';
import LessonHeader from '@/components/Lesson/Header/LessonHeader';

export default {
  components: {
    BrowserMessageDisplay,
    LessonHeader
  },
  data: () => {
    return {
      title: 'Page Not Found',
      description: 'Sorry, the page you are trying to open could not be found.'
    };
  },
  methods: {
    /**
     * Go To MyBizmates Portal
     *
     */
    goToBizmatesPortal() {
      redirectToHome(errorCodes.ME003);
    }
  }
};
</script>
